import { Box } from '@factorialco/deprecated-design-system'

import { Separator } from 'modules/integrations/components/SyncFooter/Separator'
import { useIntegrationsSyncContext } from 'modules/integrations/hooks/SyncContext'

import { BlockingIssues } from './BlockingIssues'
import { IntegrationSettingsLink } from './IntegrationSettingsLink'
import { LastSync } from './LastSync'

export const SyncFooter = () => {
  const { syncEnabled } = useIntegrationsSyncContext()

  if (!syncEnabled) return null

  return (
    <Box
      paddingTop="s8"
      paddingBottom="s12"
      paddingX="s24"
      background="grey100"
      style={{
        position: 'fixed',
        bottom: '0',
        width: '100%',
        marginLeft: '-24px',
        marginTop: '-17px',
        zIndex: '10',
        borderBottomLeftRadius: '14px',
        borderBottomRightRadius: '14px',
        alignItems: 'center',
        flexDirection: 'row',
        gap: '8px',
      }}
    >
      <LastSync />
      <Separator />
      <BlockingIssues />
      <IntegrationSettingsLink />
    </Box>
  )
}
